import React from 'react';
import { FiMap } from 'react-icons/fi';
import { getSizeOption } from '../pages/printableMapConstants';
import '../pages/printable-map-shell.css';

export function PrintableMapOrderSummary({
  boundaryName,
  size,
  orientation,
  title,
}) {
  const sizeLabel = getSizeOption(size).label;
  const orientationLabel = orientation === 'landscape' ? 'Landscape' : 'Portrait';

  return (
    <aside className="pm-summary">
      <div className="y-card pm-summary__card">
        <div className="pm-summary__head">
          <span className="pm-mono-label">Print summary</span>
          <FiMap aria-hidden="true" />
        </div>
        <div className="pm-summary__rows">
          <div className="pm-summary__row">
            <span>Boundary</span>
            <span>{boundaryName || '—'}</span>
          </div>
          <div className="pm-summary__row">
            <span>Size</span>
            <span>{sizeLabel}</span>
          </div>
          <div className="pm-summary__row">
            <span>Orientation</span>
            <span>{orientationLabel}</span>
          </div>
          <div className="pm-summary__row">
            <span>Title</span>
            <span>{title?.trim() || '—'}</span>
          </div>
        </div>
      </div>
      <div className="pm-summary__note">
        <span>Download the PDF and take it to a print shop. Print at 100% / actual size.</span>
      </div>
    </aside>
  );
}
